import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { stateChip, levels, type State, type Level } from './tokens'

/**
 * StateTag — etiqueta de estado (cap. 05; ADR-013). Recebe o ESTADO (enum), nunca cor: a chapa e o texto vêm de
 * [data-state] + [data-surface] nas custom properties geradas (o violeta clareia sobre tinta por CSS — token `accentOnInk` —, não por prop).
 * Aba: dois cantos do mesmo lado, raio 10% da altura (ADR-002). Nó opcional para a leitura "acende" (ADR-004).
 */
export function StateTag({ state, children, withNode = true, className }: { state: State; children?: ReactNode; withNode?: boolean; className?: string }) {
  const { i18n } = useTranslation()
  const lng = i18n.language?.startsWith('en') ? 'en' : 'pt'
  return (
    <span className={['z-tag', className].filter(Boolean).join(' ')} data-state={state} data-anatomy="etiqueta">
      {withNode && <span className="z-no" data-role="no" aria-hidden="true" />}
      {children ?? stateChip[state].label[lng]}
    </span>
  )
}

/** LevelChip — nível de autonomia L0–L5 (cap. 03): "L3 · Corrige com aprovação". Mono, caixa alta, estado Construção. */
export function LevelChip({ level, className }: { level: Level; className?: string }) {
  const { i18n } = useTranslation()
  const lng = i18n.language?.startsWith('en') ? 'en' : 'pt'
  const l = levels[level]
  return (
    <span className={['z-tag', className].filter(Boolean).join(' ')} data-state={level >= 5 ? 'cura' : 'construcao'} data-level={level} data-anatomy="etiqueta">
      L{level} · {l[lng]}
    </span>
  )
}

export default StateTag
